import { BREAKPOINT_NARROW_MOBILE_PX } from '../global/constants'
import { useMediaQuery } from '../global/useMediaQuery'

export const useIsMobileScreen = (): boolean => {
  return useMediaQuery(`(max-width: ${BREAKPOINT_NARROW_MOBILE_PX - 1}px)`)
}
